import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';
import ClientsList from "./ClientsList";
import NewClientForm from "./NewClientForm";
import './Client.css'; // Main CSS file for this page

const Client = () => {
    const [activeTab, setActiveTab] = useState('Client List');
    const [editClientId, setEditClientId] = useState(null);
    const [showEditDrawer, setShowEditDrawer] = useState(false);
    const [leadData, setLeadData] = useState(null); // Used if converting from lead

    const [selectedCountry, setSelectedCountry] = useState('all');
    const [countryFilterOpen, setCountryFilterOpen] = useState(false);
    const [countriesList, setCountriesList] = useState([]);
    const countryFilterRef = useRef(null);

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const token = localStorage.getItem("token");
                const res = await axios.get('https://skcapi.btcjapan.co/get_client_countries.php', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (res.data.success) setCountriesList(res.data.data);
            } catch (err) {
                console.error("Failed to load countries:", err);
            }
        };
        fetchCountries();
    }, []);

    // Close dropdown on outside click
    useEffect(() => {
        const handler = (e) => {
            if (countryFilterRef.current && !countryFilterRef.current.contains(e.target)) {
                setCountryFilterOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);    
    
    const userType = localStorage.getItem("usertype");
    const userFullName = (localStorage.getItem("fname") || "") + " " + (localStorage.getItem("lname") || "");

    // ====== HANDLE CLIENT CREATED ======
    const handleClientCreated = () => {
        setActiveTab('Client List');
    };

    // ====== OPEN EDIT DRAWER ======
    const openEditDrawer = (id) => {
        setEditClientId(id);
        setShowEditDrawer(true);
    };

    // ====== CLOSE EDIT DRAWER ======
    const closeEditDrawer = () => {
        setShowEditDrawer(false);
        setEditClientId(null);
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <SuperAdminSidebar />}
                {userType === "leader" && <LeaderSidebar />}
                {userType === "manager" && <ManagerSidebar />}
                {userType === "member" && <MemberSidebar />}
            </div>

            <div className="admin-content">
                <AdminNavbar />
                <div className="main-content">
                    <div className="main-section">
                        <h3 className="section-title">Clients</h3>

                        {/* Tabs + Country Filter */}
                        <div className="client-tabs-container">
                            <div className="client-tabs-left">
                                <button 
                                    className={`client-tab-btn ${activeTab === 'Client List' ? 'active-tab' : ''}`}
                                    onClick={() => setActiveTab('Client List')}
                                >
                                    Client List
                                </button>
                                {/*                          */}
                                {/* <button ... New Client tab ... </button> */}
                                {/*                          */}
                            </div>

                            {/* Country Filter Dropdown */}
                            <div className="leads-filter-wrap" ref={countryFilterRef}>
                                <button
                                    type="button"
                                    className="leads-filter-trigger"
                                    onClick={() => setCountryFilterOpen(open => !open)}
                                >
                                    <span className="leads-filter-label">Filter by Country</span>
                                    <span className="leads-filter-value">
                                        {selectedCountry === 'all' ? 'All' : selectedCountry}
                                    </span>
                                    <span className={`leads-filter-caret ${countryFilterOpen ? 'open' : ''}`}>▾</span>
                                </button>

                                {countryFilterOpen && (
                                    <div className="leads-filter-menu">
                                        <button
                                            type="button"
                                            className={`leads-filter-item ${selectedCountry === 'all' ? 'active' : ''}`}
                                            onClick={() => { setSelectedCountry('all'); setCountryFilterOpen(false); }}
                                        >
                                            All
                                        </button>
                                        {countriesList.map(country => (
                                            <button
                                                key={country}
                                                type="button"
                                                className={`leads-filter-item ${selectedCountry === country ? 'active' : ''}`}
                                                onClick={() => { setSelectedCountry(country); setCountryFilterOpen(false); }}
                                            >
                                                {country}
                                            </button>
                                        ))}
                                        {countriesList.length === 0 && (
                                            <div className="leads-filter-empty">No countries available</div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Tab Content Area */}
                        <div className="client-content-area">
                            {activeTab === 'Client List' && (
                                <ClientsList
                                    openEditDrawer={openEditDrawer}
                                    refreshTrigger={activeTab}
                                    filter={selectedCountry}
                                />
                            )}
                            {activeTab === 'New Client' && <NewClientForm onClientCreated={handleClientCreated} currentUserFullName={userFullName} />}
                        </div>

                    </div>
                </div>
            </div>

            {/* ========== EDIT SIDE DRAWER ========== */}
            {showEditDrawer && (
                <div style={{
                    position: 'fixed', top: 0, right: 0, width: '520px', height: '100vh',
                    background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 9999,
                    overflowY: 'auto', padding: '20px'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                        <h3 style={{ margin: 0 }}>Edit Client</h3>
                        <button onClick={closeEditDrawer} style={{ background: 'transparent', border: 'none', fontSize: 24, cursor: 'pointer', lineHeight: 1 }}>×</button>
                    </div>

                    <NewClientForm
                        mode="edit"
                        clientId={editClientId}
                        onClientCreated={() => {
                            closeEditDrawer();
                            setActiveTab('Client List');
                        }}
                        currentUserFullName={userFullName}
                        onCancel={closeEditDrawer}
                    />
                </div>
            )}

            {/* Overlay */}
            {showEditDrawer && (
                <div onClick={closeEditDrawer} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 9998 }} />
            )}
        </div>
    )
}

export default Client;